"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * lazy decorator
 *
 * @lazy()
 * get prop() : T {
 *   // code to create the return type and then once
 *   // created it is cached for future invocations
 * }
 */
function lazy() {
    return function (target, propertyKey, descriptor) {
        var configurable = descriptor.configurable, enumerable = descriptor.enumerable, writable = descriptor.writable;
        var innerGet = descriptor.get;
        if (typeof innerGet === 'function') {
            var getter = function () {
                // tslint:disable-next-line:no-invalid-this
                var val = innerGet.apply(this);
                // tslint:disable-next-line:no-invalid-this
                Object.defineProperty(this, propertyKey, {
                    configurable: configurable, enumerable: enumerable, writable: writable, value: val
                });
                return val;
            };
            descriptor.get = getter;
        }
        return descriptor;
    };
}
exports.lazy = lazy;
//# sourceMappingURL=lazy.js.map